export default [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/pages/public/components/login/Login'),
    meta: { onlyAnonymous: true },
  }
];
